/** Figma asset URLs (MCP); replace with CDN if these expire. */
export const MOBILE_PHONE_SCREENSHOT_LEFT_URL =
    'https://p1.liveauctioneers.com/dist/images/app_download_prompt_mobile.png';

export const MOBILE_PHONE_SCREENSHOT_RIGHT_URL =
    'https://p1.liveauctioneers.com/dist/images/app_download_prompt_mobile_right.png';

/** Modal shell: single 8px radius on all corners to avoid stacked-radius artifacts. */
export const appDownloadPromoComposableModalClassName =
    'w-full min-w-0 !max-w-[min(calc(100vw-2rem),844px)] !p-0 !rounded-lg';
